<template>
    <div class="collect fix">
        <div class="conLeft fl w380">
            <collectClassify @itemClick="itemClick"></collectClassify>
        </div>
        <div class="conRight fr w780">
            <collectAuction v-if="collectSelect==1" 
                            @sendGoodClick="openGoodInfoForm"
                            :list="collectAuctionList"
            >
            </collectAuction>
            <collectGoodList v-else-if="collectSelect==2" @itemClick="itemClick" @sendGoodClick="openGoodInfoForm" :list="postSendList"></collectGoodList>
            <template v-else>
                <collectDetails />
            </template>
        </div>
        <el-dialog :visible.sync="goodInfoShow" destroy-on-close>
            <goodInfoForm class="goodInfoForm" :formId="formId" :max="1" @closeDialog="closeDialog"></goodInfoForm>
        </el-dialog>
    </div>
</template>

<script>
import collectClassify from "../components/collect/collectClassify";
import collectAuction from "../components/collect/collectAuction";
import collectGoodList from "../components/collect/collectGoodList";
import collectDetails from '../components/collect/collectDetail.vue'
import goodInfoForm from "../components/collect/upload/UploadFile";
import { postDetail, postCollect, postSend } from '@/api/company'
import { mapActions, mapGetters } from "vuex";

export default {
    name: "collect",
    data(){
        return{
            collectSelect:this.$route.query.id || 1,
            goodInfoShow:false,
            collectAuctionList:[],
            postSendList: [],
            collectDetail: '',
            formId: ''
        }
    },
    computed:{
        ...mapGetters({
            getIsLoadIng: "pageOrgMeta/getIsLoadIng",
            getData: "pageOrgMeta/getData",
        }),
    },
    // //服务端渲染
    asyncData({ store,route }) {
        let params = {
            type:11,
            zone_name:route.params.name
        }
        return store.dispatch("pageOrgMeta/setOrgMeta", [params, () => {}]);
    },
    mounted() {
        const webNames = this.$router.history.current.params.name;
        this.postDetail(webNames);
        const webName = this.$route.params.name;
        if (!this.getIsLoadIng){
            let parmas = {
                type:11,
                zone_name:webName
            }
            this.setOrgMeta([parmas,()=>{
                this.filteData();
            }])
        }else{
            this.filteData();
        }
    },
    methods:{
        ...mapActions({
            setOrgMeta:"pageOrgMeta/setOrgMeta"
        }),
        filteData(){
            let data = this.$store.state["pageOrgMeta"]["data"]
            console.log(data,'pageOrgMeta')
            document.title = data.meta ? data.meta.title :'';
            let head = document.getElementsByTagName('head');
            this.isLoading = false
            if(!document.querySelector('meta[name=description]')){
                let meta = document.createElement('meta');
                meta.name = 'description';
                meta.content = data.meta ? data.meta.description : '';
                head[0].appendChild(meta)
            }else{
                document.querySelector('meta[name=description]').setAttribute('content',data.meta ? data.meta.description : '')
            }
        },
        itemClick(id, index){
            if(id === 3) return this.$router.push(`/${this.$router.history.current.params.name}/collect?id=${id}&index=${index}`);
            this.$router.push(`/${this.$router.history.current.params.name}/collect?id=${id}`)
        },
        openGoodInfoForm(id){
            if(id) {
                this.formId = id
            }
            this.goodInfoShow=true;
        },
        closeDialog(){
            this.goodInfoShow=false;
        },
        postDetail(name) {
            postDetail({
                web_name: name
            }).then(res => {
                this.postCollect(res.data.organ_id)
                this.postSend(res.data.organ_id)
            })
        },
        postCollect(id) {
            postCollect({
                organCode: id
            }).then(res => {
                this.collectAuctionList = res.data.list
                console.log('征集送拍',res.data.list);
            })
        },
        postSend(id){
            postSend({
                organCode: id
            }).then(res => {
                this.postSendList = res.data.list
            })
        },
        beforeClose() {
            console.log('关闭');
        }
    },
    components:{
        collectClassify,
        collectAuction,
        collectGoodList,
        goodInfoForm,
        collectDetails
    }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/auctionCompany.scss";
.collect{

}
.bgMark{
    z-index: 13;
    background: none 0% 0% repeat scroll rgb(0, 0, 0);
    opacity: 0.7;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    .goodInfoForm{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
    }
}
</style>